export default __webpack_public_path__ + "img/f22de09c62f5cd9b8d374f7f2bb7aaa8.svg";